import { useEffect, useState } from "react";
import delay from "lodash/delay";
import { Box } from "@chakra-ui/react";
import { Analytics, Download, Hero, Rarity, Rewards } from "./sections";

export const AppLandingPageView = () => {
  const [isVisible, setIsVisible] = useState(true);

  // To get around the layout jump with mobile
  // Additionally there are 2 big videos that need to load (one for each theme)
  useEffect(() => {
    delay(() => {
      setIsVisible(false);
    }, 300);
  }, [setIsVisible]);

  return (
    <Box position="relative">
      <Box
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        bg="ui-bg"
        zIndex="99999"
        opacity={isVisible ? 1 : 0}
        pointerEvents="none"
        transition="opacity 150ms ease-in"
      />
      <Hero />
      <Analytics />
      <Rarity />
      <Rewards />
      <Download />
    </Box>
  );
};
